import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { ToastContainer } from 'react-toastify';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './lib/queryClient';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import BugsnagPerformance from '@bugsnag/browser-performance';
import './styles/components.module.css';
import './styles/top_loader.scss';
import './styles/index.css';
import './styles/tailwind.css';
import 'react-toastify/dist/ReactToastify.css';
import 'react-datepicker/dist/react-datepicker.css';
import './styles/datepicker-overrides.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import statesStore, { persistor } from './states';
import Router from './routes';
import { ThemeProvider } from './contexts/ThemeContext';
import LuckyOrangeTracker from './routes/LuckyOrangeTRacker';
import LuckyOrangeLoader from './components/LuckyOrangeLoader';

const bugsnag_env = process.env.REACT_APP_BUGSNAG_ENVIRONMENT;
const bugsnag_api_key = process.env.REACT_APP_BUGSNAG_API_KEY || '';

Bugsnag.start({
  apiKey: bugsnag_api_key,
  plugins: [new BugsnagPluginReact()],
  releaseStage: bugsnag_env
});

BugsnagPerformance.start({ apiKey: bugsnag_api_key });

const ErrorBoundary: any = Bugsnag.getPlugin('react')?.createErrorBoundary(React);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ErrorBoundary>
    <React.StrictMode>
      <HelmetProvider>
      <ThemeProvider>
        <Provider store={statesStore}>
          <PersistGate loading={null} persistor={persistor}>
            <QueryClientProvider client={queryClient}>
              <BrowserRouter>
                <LuckyOrangeLoader />
                <LuckyOrangeTracker />
                <Router />
              </BrowserRouter>
              <ToastContainer autoClose={600} closeButton position="top-right" style={{zIndex:99999}}/>
              <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
          </PersistGate>
        </Provider>
      </ThemeProvider>
      </HelmetProvider>
    </React.StrictMode>
  </ErrorBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
